import { useAppSelector } from '../../hooks';
import { selectIsOverlayOpen, selectShouldShowNav, selectShouldShowToolbar } from '../selectors';
export function useOverlayState() {
  const isOverlayOpen = useAppSelector(selectIsOverlayOpen);
  const shouldShowNav = useAppSelector(selectShouldShowNav);
  const shouldShowToolbar = useAppSelector(selectShouldShowToolbar);
  return [isOverlayOpen, shouldShowNav, shouldShowToolbar];
}